<div class="flex-col flex">
    @if (mappedItem$$ | async) {
        <cb-document
            [entity]="mappedItem"
            [permissions]="documentPermissions"
            (documentsChange)="lotMappedItemChange.emit(lotMappedItem)"
            [includeLinked]="true"
            [includeDeleted]="false"
            [hideDeletedToggle]="true"
            [systemArea]="systemArea"
            [documentStubGroupCode]="documentStubGroupCode"
            [hideDocumentStubButton]="false"
            [documentStubDialogTitle]="'Design Requirements'"
            [showPdfButton]="true"
        >
        </cb-document>
    }
</div>
